import { type IAreaTicket } from '../../../models/area-ticket-model';
import { LanguageService } from '../../../services/language.service';
import AreaTicketApiModel from '../AreaTicket/models/area-ticket.api-model';
import AreaTicket from '../AreaTicket';
import { useTexts } from '../../../hooks/texts.hook';
import Spinner from '../../Shared/Spinner';
import useFetch, { Status } from '../../../hooks/fetch.hook';
import Alert from '../../Shared/Alert';
import type { IServerSideRendered } from '../../Shared/Base/server-side-rendered';

export type IAreaTicketDetailsTexts = object;

export interface IAreaTicketDetailsSettings {
  areaTicketGuid: string;
}

type IAreaTicketDetailsProps = IServerSideRendered<IAreaTicketDetailsTexts, IAreaTicketDetailsSettings>;

// === FUNCTIONS ===
function processReceivedData(data: AreaTicketApiModel): IAreaTicket {
  return AreaTicketApiModel.mapToBusinessModel(data);
}

function AreaTicketDetails({ settings }: IAreaTicketDetailsProps) {
  // === CONSTANTS ===
  const areaTicketGuid = settings.areaTicketGuid;

  // === HOOKS ===
  const { t } = useTexts();

  // === STATE ===
  const [{ status: getMatchingAreaTicketDetailsStatus, data: getMatchingAreaTicketDetailsData }] = useFetch<AreaTicketApiModel>(
    `/api/areatickets/${areaTicketGuid}?language=${LanguageService.getCurrentLanguage()}`,
  );
  // === VARAIBLES ===
  const areaTicketDetails = getMatchingAreaTicketDetailsData !== undefined ? processReceivedData(getMatchingAreaTicketDetailsData) : undefined;

  return (
    <div className="area-ticket-details-components">
      {getMatchingAreaTicketDetailsStatus === Status.loading && <Spinner />}

      <Alert
        show={getMatchingAreaTicketDetailsStatus === Status.failed}
        heading={t(
          'Just nu kan vi inte visa information för detta område. Vänligen kontakta kundservice.',
          'Unfortunately, we cannot display information for this area right now. Please contact customer service.',
        )}
        closable={false}
      />

      {getMatchingAreaTicketDetailsStatus !== Status.loading && areaTicketDetails && <AreaTicket areaTicket={areaTicketDetails} isDetailsPage={true}></AreaTicket>}
    </div>
  );
}

export default AreaTicketDetails;
